import React from 'react';
import { Sidebar } from '@/components/navigation/Sidebar';
import { Header } from '@/components/navigation/Header';
import { MobileDrawer } from '@/components/navigation/MobileDrawer';
import { CommandPalette } from '@/components/overlays/CommandPalette';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';
import { SessionTimeoutModal } from '@/features/auth/components/SessionTimeoutModal';
import { useShellState } from '@/app/context/ShellContext';

import { cn } from '@/lib/utils';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayoutContent: React.FC<MainLayoutProps> = ({ children }) => {
  const { isOnline, isSidebarCollapsed } = useShellState();

  return (
    <div className="flex min-h-screen bg-background text-foreground font-poppins">
      <Sidebar />
      <MobileDrawer />
      <CommandPalette />
      <SessionTimeoutModal />

      <div
        className={cn(
          'flex flex-1 flex-col min-w-0 transition-all duration-300',
          isSidebarCollapsed ? 'lg:pl-20' : 'lg:pl-64'
        )}
      >
        {!isOnline && (
          <div className="bg-rose-600 text-white text-xs font-bold py-1 px-4 text-center">
            Connection Lost. You are viewing cached offline data. Actions will sync when connection is restored.
          </div>
        )}
        <Header />
        <main className="flex-1 p-4 sm:p-6 md:p-8 max-w-[1560px] w-full mx-auto space-y-6">
          <ErrorBoundary>{children}</ErrorBoundary>
        </main>
      </div>
    </div>
  );
};

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return <MainLayoutContent>{children}</MainLayoutContent>;
};
